const store = {
    username: "",
    password: ""
};
export default store;
